'use client';

import type { PropsWithChildren } from 'react';
import { motion } from 'framer-motion';
import { useFilteredBlogPostState } from './FilteredBlogPostProvider';

export interface FilteredBlogPostWrapperProps extends PropsWithChildren {
    postId: number;
}

export function FilteredBlogPostWrapper({ children, postId }: FilteredBlogPostWrapperProps) {
    const { visiblePostIds } = useFilteredBlogPostState();

    return visiblePostIds.includes(postId) ? (
        <motion.div className="w-full sm:max-w-[calc(50%-12px)] md:max-w-[calc(32.8%-12px)] flex items-stretch" layout>
            {children}
        </motion.div>
    ) : null;
}
